import { ColorName } from 'types';
import { ProductType } from 'types/api/product.type';

import { NotificationModal } from 'pages/Catalogue/components/NotificationModal';

import { Icon } from 'components/Icon';
import { useNotification } from 'components/Notification/Notification.hooks';

import * as S from './Notification.styles';
import { StyledNotificationType } from './Notification.styles';

type NotificationProps = {
  children?: React.ReactNode;
  amount: number;
  data?: ProductType;
  notificationUnRead?: boolean;
  color?: ColorName;
} & StyledNotificationType;

export function Notification(props: NotificationProps): React.ReactElement {
  const { children = undefined, amount, data, notificationUnRead = true, color } = props;

  const {
    showNotificationModal,
    hideNotificationModal,
    notificationModalVisible,
    notificationsDetails,
  } = useNotification(data);
  const notificationColor = color || (notificationUnRead ? 'red' : 'green');

  return (
    <S.Container>
      {children ? <S.Label>{children}</S.Label> : null}

      <S.Wrapper
        notificationColor={notificationColor}
        onClick={(e) => {
          if (!data) return;
          e.preventDefault();
          e.stopPropagation();
          showNotificationModal();
        }}
      >
        {notificationUnRead ? <Icon name="FiBell" color="white" /> : <S.Item>{amount}</S.Item>}
      </S.Wrapper>
      {notificationModalVisible && (
        <NotificationModal data={notificationsDetails} onClose={hideNotificationModal} />
      )}
    </S.Container>
  );
}
